export type NavItem = {
  label: string;
  path: string;
  icon: string;
  notify?: "disputes";
};

export type NavSection = {
  title: string;
  items: NavItem[];
};

export const ADMIN_NAV: NavSection[] = [
  {
    title: "Users",
    items: [
      { label: "Users", path: "/", icon: "group" },
      { label: "KYC", path: "/kyc", icon: "badge" },
      { label: "KYC V2", path: "/kyc-v2", icon: "verified_user" },
      { label: "Owners", path: "/owners", icon: "admin_panel_settings" },
    ],
  },
  {
    title: "Transactions",
    items: [
      {
        label: "On-chain",
        path: "/transactions",
        icon: "account_balance_wallet",
      },
      { label: "Internal", path: "/internal-transactions", icon: "swap_horiz" },
      { label: "CPG", path: "/cpg-order-flow", icon: "payments" },
      { label: "X Ramp", path: "/prime-order-flow", icon: "currency_exchange" },
      { label: "Balances", path: "/balances", icon: "account_balance" },
      { label: "Settlements", path: "/settle-accounts", icon: "handshake" },
    ],
  },
  {
    title: "Compliance",
    items: [
      {
        label: "Disputes",
        path: "/prime-dispute-resolution",
        icon: "gavel",
        notify: "disputes",
      },
      { label: "Wallet blocklist", path: "/wallet-blocklist", icon: "block" },
      { label: "IP blocklist", path: "/ip-blocklist", icon: "vpn_lock" },
      { label: "FINTRAC", path: "/fintrac", icon: "policy" },
    ],
  },
  {
    title: "Network",
    items: [
      {
        label: "Institutions",
        path: "/institution-management",
        icon: "apartment",
      },
      { label: "Cashiers", path: "/cashier-management", icon: "point_of_sale" },
      {
        label: "Referrals",
        path: "/cashier-referral-program",
        icon: "loyalty",
      },
      { label: "Affiliates", path: "/affiliate-management", icon: "diversity_3" },
      { label: "Ivy", path: "/ivy-affiliate", icon: "hub" },
      { label: "Groups", path: "/groups", icon: "groups" },
    ],
  },
  {
    title: "Finance",
    items: [
      { label: "Off-ramp", path: "/invoice-approvals", icon: "payments" },
      { label: "Rates", path: "/rates", icon: "percent" },
      { label: "Revenue", path: "/revenue", icon: "trending_up" },
      { label: "Billing", path: "/billing", icon: "receipt_long" },
      { label: "Analytics", path: "/analytics", icon: "monitoring" },
    ],
  },
  {
    title: "Platform",
    items: [
      { label: "App config", path: "/app-config", icon: "tune" },
      { label: "Email logs", path: "/email-logs", icon: "mail" },
    ],
  },
];

const ALL_PATHS = ADMIN_NAV.flatMap((section) =>
  section.items.map((item) => item.path),
);

export const isNavItemActive = (pathname: string, path: string) => {
  if (path === "/") {
    return !ALL_PATHS.some(
      (other) =>
        other !== "/" &&
        (pathname === other || pathname.startsWith(`${other}/`)),
    );
  }

  return pathname === path || pathname.startsWith(`${path}/`);
};

export const filterNav = (sections: NavSection[], query: string) => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return sections;

  return sections
    .map((section) => ({
      ...section,
      items: section.items.filter(
        (item) =>
          item.label.toLowerCase().includes(normalized) ||
          section.title.toLowerCase().includes(normalized),
      ),
    }))
    .filter((section) => section.items.length > 0);
};
